//angular imports
import { 
  Signal, 
  WritableSignal, 
  computed, 
  signal 
} from "@angular/core";

//local imports
import { IMenu } from "@app/core";
import { IListItem, ListItem, Messenger } from "@app/shared";
import { AbstractProgramModel, TypedNavItem } from "@app/catalog-common";

export abstract class AbstractProgramNavModel<TProgram extends AbstractProgramModel>
  extends TypedNavItem<ListItem<TProgram>>
  implements IMenu
{
  public isLoading?: Signal<boolean>;
  public isDisabled?: Signal<boolean>;
  public subMenu?: WritableSignal<IMenu> = signal<IMenu>(null);

  constructor(
    protected messenger: Messenger,
    items: Signal<TProgram[]>,
    isLoading?: Signal<boolean> 
  ) {
    super();

    this.isLoading = isLoading ?? signal<boolean>(false);
    this.items = computed(() =>
      items()
      .sort((a,b)=>a.name() > b.name() ? 1 : -1)
      .map(item => item.toListItem$(item.isChecked))
    );
  }

  public abstract select(item: IListItem): void;
}
